module.exports = __webpack_public_path__ + "static/media/IMG_0384.8630c4b3.JPG";